module.exports = __webpack_public_path__ + "static/media/iict.c4bff445.jpeg";